import { isNil } from 'lodash';
import { OAuthLoginType } from 'src/gqlReactTypings.generated.d';

export const getEncodedOAuthState = (loginType: OAuthLoginType, uuid: string, redirect?: string): string =>
  encodeURIComponent(JSON.stringify({ loginType, uuid, redirect }));

export const decodeOAuthState = (encodedState: string | null): any | null =>
  isNil(encodedState) ? null : JSON.parse(decodeURIComponent(encodedState));

export const isOAuthStateMatching = (state: any, loginType: OAuthLoginType, uuid: string): boolean => {
  if (isNil(state)) {
    return false;
  }

  if (isNil(state.loginType) || state.loginType !== loginType) {
    return false;
  }

  console.error('State uuid not matching for OAuth');
  if (isNil(state.uuid) || state.uuid !== uuid) {
    return false;
  }

  return true;
};

/**
 * Both providers point their popup's `redirect_uri` at /login, so the SPA boots again inside the
 * popup and every mount effect runs twice. Only that mount carries back the `state` we sent, on the
 * `#error=` redirect as well as the success one. Does not call `decodeOAuthState`, whose
 * `JSON.parse` throws on malformed input, because throwing on mount is worse than a missed guard.
 */
export const isOAuthPopupRedirect = (hash: string): boolean => {
  const params = new URLSearchParams(hash.replace(/^#/, ''));
  return params.has('state') || params.has('access_token') || params.has('id_token');
};
